<template>
    <div class="">
        <div class="scrollH">
            <div class="gradient absolute h-full" v-show="filterIsScrollable && filterIsScrolledLeft"></div>
            <!--Left Gradient-->

            <div class="scroll-nav flex w-full overflow-y-hidden overflow-x-auto flex-no-wrap" ref="filterNav">

                <div ref="filterNavButton">
                    <button v-for="(tab, index) in tabs"
                            :key="index"
                            :title="tab.name"
                            @click="onChange(tab.slug)"
                            :class="{ 'active': selected === tab.slug }"
                            class="text-18 font-bold bg-white border-none mr-l text-onyx cursor-pointer">

                        <span class="tab-header">{{ tab.name }}</span>

                    </button>
                </div>
            </div>

            <div class="gradient absolute right h-full"></div>
            <!--Right gradient-->
        </div>

        <!--selected tab content to be displayed-->
        <div id="load-articles">
            <tab-content :allArticles="articles"
                         :url-blog-show="urlBlogShow"
                         :url-blog-category="urlBlogCategory"
                         :slug="selected"
            ></tab-content>
        </div>
    </div>
</template>

<script>
    import TabContent from "./components/TabContent";

    export default {
        props: {
            allArticles: {
                type: Object,
                required: true
            },
            urlBlogShow: {
                type: String,
                required: true
            },
            urlBlogCategory: {
                type: String,
                required: true
            },
            tags : {
                type : Array,
                required : true,
            }
        },

        data() {
            return {
                tabs: [
                    {
                        name: 'All',
                        slug: 'all'
                    },
                    ...this.tags
                ],
                selected: "all",
                filterIsScrollable: false,
                filterIsScrolledRight: false,
                filterIsScrolledLeft: false,
                scrollWidth: 0,
                articles: this.allArticles,
            }
        },

        components: {
            TabContent
        },

        methods: {
            filterNavScrolled() {
                const navContent = this.$refs.filterNavButton.getBoundingClientRect();
                const navWrapper = this.$refs.filterNav.getBoundingClientRect();
                const xFinal = navWrapper.left - (navContent.width - navWrapper.width);

                this.checkIfOverflowing();
                this.filterIsScrolledLeft = (navContent.x < navWrapper.x);
                this.filterIsScrolledRight = (navContent.x > xFinal);
            },

            async onChange(slug) {
                this.selected = slug;

                this.$vs.loading({
                    container: "#load-articles",
                    scale: 0.8
                });

                let url = this.selected === "all" ? this.urlBlogShow : `${this.urlBlogCategory}/${slug}`;

                try {
                    const { data } = await axios.get(url)
                    this.articles = data
                    this.$vs.loading.close( "#load-articles > .con-vs-loading");
                } catch (e) {
                    console.log(e)
                }

                this.checkIfOverflowing();
            },

            checkIfOverflowing(e) {
                let element = this.$refs.filterNav;

                if (element) this.filterIsScrollable = (element.clientWidth < element.scrollWidth);
            },
        },

        mounted() {
            this.$refs.filterNav.addEventListener("scroll", this.filterNavScrolled);

            this.filterNavScrolled();
        }
    }
</script>

<style lang="scss" scoped>
    .scrollH {
        /*padding-left: 12px;*/
        max-width: 100%;
        display: flex;
        position: relative;
        height: 100%;

        & > * {
            flex: 0 0 auto;
        }

        .scroll-nav {
            z-index: 50;

            & > * {
                flex: 0 0 auto;
            }

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .gradient {
            pointer-events: none;
            z-index: 100;
            width: 53px;
            left: 0;
            bottom: 0;
            background-image: linear-gradient(to right, var(--white) 0%, rgba(255, 255, 255, 0) 100%);

            &.right {
                left: auto;
                right: 0;
                transform: rotate(-180deg);
            }
        }

        .active {
            padding-bottom: 2px;
            border-bottom: 2px solid var(--primary) !important;
        }

        .tab-header{
            font-family: 'Montserrat';
        }

        @media (min-width: 1024px) {
            min-width: 89px;
        }

        @media (min-width: 1280px) {
            flex: 2 !important;
            max-width: 100%;
            margin-right: 15px;
        }
    }
</style>
